"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMessage = parseMessage;
const libs_parsing_1 = require("libs.parsing");
/**
 * Parses a message into a parse tree.
 * @param message String conforming to the Medable Message Format representing the message to parse.
 * @returns A parse tree representing the message.
 */
function parseMessage(message) {
    const reader = new libs_parsing_1.StringReader(message);
    const messageNodes = [];
    let textBuffer = [];
    while (!reader.reachedEnd()) {
        if (reader.getChar() === '<') {
            if (textBuffer.length > 0) {
                messageNodes.push(textBuffer.join(''));
                textBuffer = [];
            }
            reader.advance();
            messageNodes.push(parseHtmlTag(reader));
        }
        else if (reader.getChar() === '{') {
            if (textBuffer.length > 0) {
                messageNodes.push(textBuffer.join(''));
                textBuffer = [];
            }
            reader.advance();
            messageNodes.push(parsePlaceholder(reader));
        }
        else if (reader.getChar() === '\\') {
            if (reader.reachedEnd()) {
                throw new libs_parsing_1.ParserError(reader, 'Unexpected end of string after an escape character');
            }
            reader.advance();
            textBuffer.push(reader.getChar());
            reader.advance();
        }
        else {
            textBuffer.push(reader.getChar());
            reader.advance();
        }
    }
    if (textBuffer.length > 0) {
        messageNodes.push(textBuffer.join(''));
        textBuffer = [];
    }
    if (messageNodes.length === 1 && typeof messageNodes[0] === 'string') {
        return messageNodes[0];
    }
    return messageNodes;
}
function parseHtmlTag(reader) {
    let isClosing = false;
    let isSelfClosing = false;
    if (reader.getChar() === '/') {
        reader.advance();
        isClosing = true;
    }
    const tagBuffer = [];
    while (/[\w\d_]/.test(reader.getChar())) {
        tagBuffer.push(reader.getChar());
        reader.advance();
    }
    if (tagBuffer.length === 0) {
        throw new libs_parsing_1.ParserError(reader, `Expected HTML tag but found "${reader.getChar()}"`);
    }
    const tag = tagBuffer.join('');
    const attrsNodes = [];
    if (reader.getChar() === ' ') {
        reader.skip(/[\s]/);
        let attrsBuffer = [];
        while (reader.getChar() !== '>' && reader.getChars(2) !== '/>') {
            if (reader.getChar() === '{') {
                if (attrsBuffer.length > 0) {
                    attrsNodes.push(attrsBuffer.join(''));
                    attrsBuffer = [];
                }
                reader.advance();
                attrsNodes.push(parsePlaceholder(reader));
            }
            else {
                attrsBuffer.push(reader.getChar());
                reader.advance();
            }
        }
        if (attrsBuffer.length > 0) {
            attrsNodes.push(attrsBuffer.join(''));
            attrsBuffer = [];
        }
    }
    if (reader.getChar() === '>' || reader.getChars(2) === '/>') {
        if (reader.getChars(2) === '/>') {
            isSelfClosing = true;
            reader.advance();
        }
        reader.advance();
        if (attrsNodes.length === 0) {
            return { tag, isClosing, isSelfClosing };
        }
        let attrs;
        if (attrsNodes.length === 1 && typeof attrsNodes[0] === 'string') {
            attrs = attrsNodes[0];
        }
        else {
            attrs = attrsNodes;
        }
        return { tag, isClosing, isSelfClosing, attrs };
    }
    throw new libs_parsing_1.ParserError(reader, `Expected ">" or attributes but found "${reader.getChar()}"`);
}
function parsePlaceholder(reader) {
    reader.skip(/[\s]/);
    const identifierBuffer = [];
    while (/[\w\d_]/.test(reader.getChar())) {
        identifierBuffer.push(reader.getChar());
        reader.advance();
    }
    if (identifierBuffer.length === 0) {
        throw new libs_parsing_1.ParserError(reader, `Expected placeholder identifier but found "${reader.getChar()}"`);
    }
    const identifier = identifierBuffer.join('');
    reader.skip(/[\s]/);
    if (reader.getChar() === '}') {
        reader.advance();
        return { identifier };
    }
    throw new libs_parsing_1.ParserError(reader, `Expected "}" but found "${reader.getChar()}"`);
}
//# sourceMappingURL=message_parser.js.map